import { createApp } from "vue";
import { router } from "@/routes";
import App from "@/App.vue";
import { createPinia, Pinia } from "pinia";
import piniaPluginPersistedState from "pinia-plugin-persistedstate";
import PrimeVue from "primevue/config";
import ConfirmationService from "primevue/confirmationservice";
import ToastService from "primevue/toastservice";
import { useAuthStore } from "@/store/auth.ts";
import { AuthenticationService } from "@/services/authentication.ts";

import JbIcon from "@/components/JBIcon.vue";
import Tooltip from "primevue/tooltip";
import ProgressSpinner from "primevue/progressspinner";
import { UserCanDirective } from "@/directives/user-can.ts";
import { type PermissionString } from "@/composables/user-permissions.ts";

const pinia: Pinia = createPinia();
pinia.use(piniaPluginPersistedState);
const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(PrimeVue, {
  theme: "none",
  options: {
    darkMode: false,
  },
});

app.directive("tooltip", Tooltip);
app.directive<HTMLElement, PermissionString>("user-can", UserCanDirective);
app.component("progressspinner", ProgressSpinner);
app.component("JBIcon", JbIcon);
app.use(ConfirmationService);
app.use(ToastService);

const authStore = useAuthStore();
authStore.setUser(AuthenticationService.getSavedUser());
app.mount("#app");
